<template>
  <div class="LoadMore">
    <template v-if="$isPc">
      <slot :finished="finished"></slot>
    </template>
    <div v-else class="load-more-wrapper" @touchstart="touchStart($event)" @touchend="touchEnd($event)">
      <div class="inner">
        <slot></slot>
        <div class="load-more" v-show="!finished">{{loadMoreText}}</div>
        <div class="load-end" v-show="finished">已经到底了!</div>
      </div>
    </div>
    <div class="load-more" v-show="$isPc && loading"><i class="el-icon-loading"></i> 加载中...</div>
  </div>
</template>
<script>
export default {
  name: "LoadMore",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    },
    onLoadMore: {
      type: Function,
      default: undefined,
      require: false
    }
  },
  data () {
    return {
      loadMoreText: "加载中...",
      startX: 0,
      startY: 0,
      isLoading: false,
    }
  },
  methods: {
    touchStart (e) {
      this.startY = e.targetTouches[0].pageY;
      this.startX = e.targetTouches[0].pageX;
    },
    scrollToEnd (e) {
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollHeight - clientHeight - scrollTop <= 150 && !this.loading && !this.finished) {
        this.doLoadMore()
      }
    },
    touchEnd (e) {
      if (this.isLoading) {
        return;
      }

      let endX = e.changedTouches[0].pageX,
        endY = e.changedTouches[0].pageY,
        dy = this.startY - endY,
        dx = endX - this.startX;
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return;
      }
      if (endY < this.startY) {
        this.scrollToEnd(e)
      }
    },
    doLoadMore () {
      this.isLoading = true
      this.loadMoreText = '加载中...'
      this.onLoadMore(this.loadDone);
    },
    loadDone () {
      this.isLoading = false;
      this.loadMoreText = '上拉加载更多'
    }
  }
}
</script>
<style lang="scss" scoped>
.load-more-wrapper {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;
}
.load-more,
.load-end {
  color: #aea699;
  font-size: 14px;
  margin: 10px 0;
  text-align: center;
}
</style>